import script from "./pre-tenancy-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./pre-tenancy-modal.vue?vue&type=script&setup=true&lang=ts"

import "./pre-tenancy-modal.vue?vue&type=style&index=0&id=e79c91d2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e79c91d2"]])

export default __exports__